import { render, staticRenderFns } from "./DashboardUnidade2.vue?vue&type=template&id=3f788a65&scoped=true"
import script from "./DashboardUnidade2.vue?vue&type=script&lang=js"
export * from "./DashboardUnidade2.vue?vue&type=script&lang=js"
import style0 from "./DashboardUnidade2.vue?vue&type=style&index=0&id=3f788a65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f788a65",
  null
  
)

export default component.exports